import { IProps } from './types'
import PlayButton from 'assets/svgr-icons/Play_Button.svg'
import DisabledPlayButton from 'assets/svgr-icons/Disabled_Play_Button.svg'
import PauseButton from 'assets/svgr-icons/Pause_Button.svg'
import * as Styled from './styled'
import { CurrentTime } from './CurrentTime'
import { formatTime } from 'utils/time-formatter'
import { useCallback, useEffect } from 'react'

export const PlayPauseButton = ({
  isPlaying,
  onPlay,
  onPause,
  duration,
  initialTime,
  disabled = false
}: IProps) => {
  const handleClick = useCallback(() => {
    if (disabled) {
      return
    }
    isPlaying ? onPause() : onPlay()
  }, [disabled, isPlaying, onPause, onPlay])

  const registerMediaSessionHandlers = useCallback(() => {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', onPlay)
      navigator.mediaSession.setActionHandler('pause', onPause)
    }
  }, [onPlay, onPause])

  useEffect(() => {
    registerMediaSessionHandlers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Styled.CenterWrapper>
      <Styled.ButtonContainer onClick={handleClick}>
        <Styled.ActionButton $isDisabled={disabled}>
          {isPlaying ? (
            <PauseButton />
          ) : disabled ? (
            <DisabledPlayButton />
          ) : (
            <PlayButton />
          )}
        </Styled.ActionButton>
        <Styled.TimeDisplay>
          <CurrentTime
            isPlaying={isPlaying}
            duration={duration}
            initialTime={initialTime}
            disabled={disabled}
            onPause={onPause}
          />
          <span>/</span>
          <span>{formatTime(duration)}</span>
        </Styled.TimeDisplay>
      </Styled.ButtonContainer>
    </Styled.CenterWrapper>
  )
}
